
import Vue from 'vue';
import Component from 'vue-class-component';
import WorkspaceUtils from '../utils/workspace-utils';
import Loader from '@/app/components/loaders/Loader.vue';
@Component({
  name: 'salesforce_callback',
  components: {
    Loader,
  },
})
export default class SalesforceCallbackComponent extends Vue {
  mounted() {
    const query = this.$route.query;
    const stateParam = query.state as string;
    let state;
    if (stateParam) {
      state = JSON.parse(stateParam);
      window.opener.postMessage(
        { event: 'emit.salesforce_callback_state', data: { query } },
        WorkspaceUtils.getCommonUrl()
      );
    }
  }
}
